<script>
  import { Router, links, link, Route, navigate } from "svelte-routing";
  import { onMount, tick } from "svelte";
  import { activeMenu } from "../../stores";
  import ThemePicker from "../themePicker/themePicker.html";
  import api_handleApiCalls from "../../utils/apiCallHandler.js";
  import { pSuccess, pError, pConfirm } from "../../utils/notify.html";
  // import ThemeCards from "../themePicker/themeCards.html";

  export let reload;
  const settings = {};
  let isLoading;
  async function fetchGeneralSettings() {
    if (isLoading) return;
    isLoading = true;
    await tick();
    let result = await api_handleApiCalls("settings.fetchGeneralSettings", {});
    console.log("fetchGeneralSettings", result);
    if (result.status) {
      settings.ALLOW_MULTIPLE_DEVICE_LOGIN =
        result.data.ALLOW_MULTIPLE_DEVICE_LOGIN || "";
      settings.ALLOW_SIGNUP = result.data.ALLOW_SIGNUP || "";
      settings.SHOW_FULL_FEES_TO_STUDENTS =
        result.data.SHOW_FULL_FEES_TO_STUDENTS || "";
      settings.INACTIVE_IF_NOT_PAID = result.data.INACTIVE_IF_NOT_PAID || "";
      settings.WEB_SITE = result.data.WEB_SITE || "";
      settings.TERMS_URL = result.data.TERMS_URL || "";
      settings.THEME = result.data.THEME || "";
      settings.WATERMARK = result.data.WATERMARK || "";
      settings.ADDRESS = result.data.ADDRESS || "";
      settings.ALLOW_SCREEN_RECORD = result.data.ALLOW_SCREEN_RECORD
      await tick();
    } else {
      pError("", result.errMsg);
    }
    isLoading = false;
    await tick();
    feather.replace({ width: "1em", height: "1em" });
  }
  async function setAllowMultipleDeviceLogins(value) {
    let result = await api_handleApiCalls("settings.setAllowMultipleDeviceLogins", { value });
    console.log("setAllowMultipleDeviceLogins", result);
    if (result.status) {
      pSuccess("", result.data);
      fetchGeneralSettings();
      if (reload) reload();
    } else {
      pError("", result.errMsg);
    }
  }
  async function setAllowScreenRecord(value) {
    let result = await api_handleApiCalls("settings.setAllowScreenRecord", { value });
    if (result.status) {
      pSuccess("", result.data);
      fetchGeneralSettings();
      if (reload) reload();
    } else {
      pError("", result.errMsg);
    }
  }
  async function setAllowSignup(value) {
    let result = await api_handleApiCalls("settings.setAllowSignup", { value });
    console.log("setAllowSignup", result);
    if (result.status) {
      pSuccess("", result.data);
      fetchGeneralSettings();
      if (reload) reload();
    } else {
      pError("", result.errMsg);
    }
  }
  async function setShowFullFeesToStudents(value) {
    let result = await api_handleApiCalls("settings.setShowFullFeesToStudents", { value });
    console.log("setShowFullFeesToStudents", result);
    if (result.status) {
      pSuccess("", result.data);
      fetchGeneralSettings();
      if (reload) reload();
    } else {
      pError("", result.errMsg);
    }
  }
  async function setInactiveIfNotPaid(value) {
    let result = await api_handleApiCalls("settings.setInactiveIfNotPaid", { value });
    console.log("setInactiveIfNotPaid", result);
    if (result.status) {
      pSuccess("", result.data);
      fetchGeneralSettings();
      if (reload) reload();
    } else {
      pError("", result.errMsg);
    }
  }
  async function setTheme(value) {
    let result = await api_handleApiCalls("settings.setTheme", { value });
    console.log("setTheme", result);
    if (result.status) {
      pSuccess("", result.data);
      fetchGeneralSettings();
      if (reload) reload();
    } else {
      pError("", result.errMsg);
    }
  }
  async function setOrganizationWebsite(value) {
    let result = await api_handleApiCalls("settings.setOrganizationWebsite", { value });
    console.log("setOrganizationWebsite", result);
    if (result.status) {
      pSuccess("", result.data);
      fetchGeneralSettings();
      if (reload) reload();
    } else {
      pError("", result.errMsg);
    }
  }
  async function setOrganizationTerms(value) {
    let result = await api_handleApiCalls("settings.setOrganizationTerms", { value });
    console.log("setOrganizationTerms", result);
    if (result.status) {
      pSuccess("", result.data);
      fetchGeneralSettings();
      if (reload) reload();
    } else {
      pError("", result.errMsg);
    }
  }
  async function setOrganizationAddress(value) {
    let result = await api_handleApiCalls("settings.setOrganizationAddress", { value });
    console.log("setOrganizationAddress", result);
    if (result.status) {
      pSuccess("", result.data);
      fetchGeneralSettings();
      if (reload) reload();
    } else {
      pError("", result.errMsg);
    }
  }
  async function setOrganizationWatermark(value) {
    let result = await api_handleApiCalls("settings.setOrganizationWatermark", { value });
    console.log("setOrganizationWatermark", result);
    if (result.status) {
      pSuccess("", result.data);
      fetchGeneralSettings();
      if (reload) reload();
    } else {
      pError("", result.errMsg);
    }
  }
  onMount(function () {
    console.log("general");
    activeMenu.set("settingsGeneral");
    fetchGeneralSettings();
  });
</script>

<div class="row">
  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xs-12">
    <ul class="list-group">
      {#if isLoading}
      <li class="list-group-item list-group-item-action">
        <div class="mg-20 pd-10">
          <div class="placeholder-paragraph">
            <div class="line mg-b-10" />
            <div class="line mg-b-10" />
          </div>
        </div>
      </li>
      {:else}
      <li class="list-group-item list-group-item-action">
        <div class="d-flex justify-content-between">
          <div>Allow Multiple Device Login</div>
          <div>
            <div class="custom-control custom-switch">
              <input
                type="checkbox"
                checked={settings.ALLOW_MULTIPLE_DEVICE_LOGIN}
                on:change={(event) => setAllowMultipleDeviceLogins(event.target.checked)}
                class="custom-control-input"
                id="allow-multiple-device-login" />
              <label
                class="custom-control-label"
                for="allow-multiple-device-login">
                {@html '&nbsp'}
              </label>
            </div>
          </div>
        </div>  
      </li>
      <li class="list-group-item list-group-item-action">
        <div class="d-flex justify-content-between">
          <div>Show Full Fee To Students</div>
          <div>
            <div class="custom-control custom-switch">
              <input
                checked={settings.SHOW_FULL_FEES_TO_STUDENTS}
                on:change={(event) => setShowFullFeesToStudents(event.target.checked)}
                type="checkbox"
                class="custom-control-input"
                id="show-full-fees" />
              <label class="custom-control-label" for="show-full-fees">
                {@html '&nbsp'}
              </label>
            </div>
          </div>
        </div>
      </li>
      <li class="list-group-item list-group-item-action">
        <div class="d-flex justify-content-between">
          <div>Allow Signup</div>
          <div>
            <div class="custom-control custom-switch">
              <input
                checked={settings.ALLOW_SIGNUP}
                on:change={(event) => setAllowSignup(event.target.checked)}
                type="checkbox"
                class="custom-control-input"
                id="allow-signup" />
              <label class="custom-control-label" for="allow-signup">
                {@html '&nbsp'}
              </label>
            </div>
          </div>
        </div>
      </li>
      <li class="list-group-item list-group-item-action">
        <div class="d-flex justify-content-between">
          <div>Inactive If Not Paid</div>
          <div>
            <div class="custom-control custom-switch">
              <input
                checked={settings.INACTIVE_IF_NOT_PAID}
                on:change={(event) => setInactiveIfNotPaid(event.target.checked)}
                type="checkbox"
                class="custom-control-input"
                id="inactive-if-not-paid" />
              <label class="custom-control-label" for="inactive-if-not-paid">
                {@html '&nbsp'}
              </label>
            </div>
          </div>
        </div>
      </li>
      <li class="list-group-item list-group-item-action">
        <div class="d-flex justify-content-between">
          <div>Allow Screen Record</div>
          <div>
            <div class="custom-control custom-switch">
              <input
                type="checkbox"
                checked={settings.ALLOW_SCREEN_RECORD}
                on:change={(event) => setAllowScreenRecord(event.target.checked)}
                class="custom-control-input"
                id="ALLOW_SCREEN_RECORD" />
              <label
                class="custom-control-label"
                for="ALLOW_SCREEN_RECORD">
                {@html '&nbsp'}
              </label>
            </div>
          </div>
        </div>  
      </li>
      <li class="list-group-item list-group-item-action">
        <div class="d-flex justify-content-between">
          <div>Organization Website URL</div>
          <nav>
            <a
              class="d-inline nav-link"
              href={settings.WEB_SITE}
              target="_blank"><i data-feather="external-link" />
              Organization website</a>
            <a
              data-toggle="collapse"
              href="#website"
              role="button"
              aria-expanded="true"
              aria-controls="website"
              class="d-inline mg-l-5 nav-link">
              <i data-feather="edit" /></a>
          </nav>
        </div>
        <div class="collapse mg-t-10" id="website">
          <div class="input-group">
            <input
              type="text"
              bind:value={settings.WEB_SITE}
              on:keyup={(event) => event.key == 'Enter' && setOrganizationWebsite(event.target.value)}
              class="form-control"
              placeholder="Website URL. Example, https://www.google.com/"
              aria-label="Website"
              aria-describedby="button-addon2" />
            <div class="input-group-append">
              <button
                on:click={(event) => setOrganizationWebsite(settings.WEB_SITE)}
                class="btn btn-outline-light"
                type="button"
                id="button-addon2">Save</button>
            </div>
          </div>
        </div>
      </li>
      <li class="list-group-item list-group-item-action">
        <div class="d-flex justify-content-between">
          <div>Terms & Conditions URL</div>
          <nav>
            <a
              class="d-inline nav-link"
              href={settings.TERMS_URL}
              target="_blank"><i data-feather="external-link" />
              Terms & Conditions URL</a>
            <a
              data-toggle="collapse"
              href="#terms"
              role="button"
              aria-expanded="true"
              aria-controls="terms"
              class="d-inline mg-l-5 nav-link">
              <i data-feather="edit" /></a>
          </nav>
        </div>
        <div class="collapse mg-t-10" id="terms">
          <div class="input-group">
            <input
              type="text"
              on:keyup={(event) => event.key == 'Enter' && setOrganizationTerms(event.target.value)}
              class="form-control"
              bind:value={settings.TERMS_URL}
              placeholder="Terms & Conditions. Example, https://www.google.com/"
              aria-label="Terms & Conditions"
              aria-describedby="button-addon2" />
            <div class="input-group-append">
              <button
                on:click={(event) => setOrganizationTerms(settings.TERMS_URL)}
                class="btn btn-outline-light"
                type="button"
                id="button-addon2">Save</button>
            </div>
          </div>
        </div>
      </li>
      <li class="list-group-item list-group-item-action">
        <div class="d-flex justify-content-between">
          <div>Select Theme</div>
          <div>
            <ThemePicker theme={settings.THEME} themeChanged={setTheme} />
            <!-- <nav>
            <a
              data-toggle="collapse"
              href="#theme"
              role="button"
              aria-expanded="true"
              aria-controls="theme"
              class="d-inline mg-l-5 nav-link">
              <i data-feather="edit" /></a>
          </nav> -->
          </div>
        </div>
        <!-- <div class="collapse mg-t-10" id="theme">
        <ThemeCards selected={settings.THEME}  changed={setTheme} />
      </div> -->
      </li>
      <li class="list-group-item list-group-item-action">
        <div class="d-flex justify-content-between">
          <div>Address</div>
          <nav>
            <a
              data-toggle="collapse"
              href="#address"
              role="button"
              aria-expanded="true"
              aria-controls="address"
              class="d-inline mg-l-5 nav-link">
              <i data-feather="edit" /></a>
          </nav>
        </div>
        <div class="collapse mg-t-10" id="address">
          <div class="input-group">
            <input
              type="text"
              on:keyup={(event) => event.key == 'Enter' && setOrganizationAddress(event.target.value)}
              class="form-control"
              bind:value={settings.ADDRESS}
              placeholder="Organization Address"
              aria-label="Organization Address"
              aria-describedby="button-addon2" />
            <div class="input-group-append">
              <button
                on:click={(event) => setOrganizationAddress(settings.ADDRESS)}
                class="btn btn-outline-light"
                type="button"
                id="button-addon2">Save</button>
            </div>
          </div>
        </div>
      </li>
      <li class="list-group-item list-group-item-action">
        <div class="d-flex justify-content-between">
          <div>Watermark</div>
          <nav>
            <a
              data-toggle="collapse"
              href="#watermark"
              role="button"
              aria-expanded="true"
              aria-controls="watermark"
              class="d-inline mg-l-5 nav-link">
              <i data-feather="edit" /></a>
          </nav>
        </div>
        <div class="collapse mg-t-10" id="watermark">
          <div class="input-group">
            <input
              type="text"
              on:keyup={(event) => event.key == 'Enter' && setOrganizationWatermark(event.target.value)}
              class="form-control"
              bind:value={settings.WATERMARK}
              placeholder="Organization Watermark"
              aria-label="Organization Watermark"
              aria-describedby="button-addon2" />
            <div class="input-group-append">
              <button
                on:click={(event) => setOrganizationWatermark(settings.WATERMARK)}
                class="btn btn-outline-light"
                type="button"
                id="button-addon2">Save</button>
            </div>
          </div>
        </div>
      </li>
            
      {/if}
    </ul>
  </div>
</div>
